import React from 'react';

import InteractiveHeaderCell, {
  IconVisibility,
  InteractiveHeaderCellProps,
} from 'ui-library/simple-table/InteractiveHeaderCell';

export type SortIcon = 'arrow-up' | 'arrow-down' | null;

export const SORT_ICON_UP = 'arrow-up' as const;
export const SORT_ICON_DOWN = 'arrow-down' as const;

export type SortableHeaderCellProps = Omit<InteractiveHeaderCellProps, 'iconInfos'> & {
  sortIcon: SortIcon;
  onToggleSort: () => void;
};

export default function SortableHeaderCell(props: SortableHeaderCellProps): JSX.Element {
  return (
    <InteractiveHeaderCell
      {...props}
      iconInfos={[
        {
          icon: props.sortIcon ?? SORT_ICON_DOWN,
          onClick: props.onToggleSort,
          visibility: props.sortIcon ? IconVisibility.ALWAYS : IconVisibility.ON_HOVER,
        },
      ]}
    />
  );
}
